import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.16.0_@types+node@24.10.1_tsx@4.20.6_typescript@5.9.3_vite@5.4.21/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}